import React from "react";

/*
 * Reglas que el frontend PUEDE validar
 */
export const passwordRules = {
    length: (password) =>
        password.length >= 12 && password.length <= 15,

    uppercase: (password) =>
        /[A-Z]/.test(password),

    lowercase: (password) =>
        /[a-z]/.test(password),

    number: (password) =>
        /[0-9]/.test(password),

    specials: (password) =>
        /[$&*%?@!]/.test(password),
};

export const isPasswordFrontendValid = (password) =>
    passwordRules.length(password) &&
    passwordRules.uppercase(password) &&
    passwordRules.lowercase(password) &&
    passwordRules.number(password) &&
    passwordRules.specials(password);

const PasswordRules = ({ password }) => {
    const rules = [
        {
            key: "noPersonalData",
            label: "No deberá incluir su CUIT, Nombre ni Apellido",
            checkable: false,
        },
        {
            key: "noReuse",
            label: "No reutilizar contraseñas previamente usadas",
            checkable: false,
        },
        {
            key: "specials",
            label: "Debe incluir alguno de estos caracteres especiales: $ & * % ? ! @",
            valid: passwordRules.specials(password),
            checkable: true,
        },
        {
            key: "length",
            label: "Longitud entre 12 y 15 caracteres",
            valid: passwordRules.length(password),
            checkable: true,
        },
        {
            key: "uppercase",
            label: "Al menos 1 letra mayúscula (A-Z)",
            valid: passwordRules.uppercase(password),
            checkable: true,
        },
        {
            key: "lowercase",
            label: "Al menos 1 letra minúscula (a-z)",
            valid: passwordRules.lowercase(password),
            checkable: true,
        },
        {
            key: "number",
            label: "Al menos 1 dígito numérico (0-9)",
            valid: passwordRules.number(password),
            checkable: true,
        }
    ];

    return (
        <div className="password-rules-wrapper">
            <ul className="password-rules">
                {rules.map(rule => {
                    let className = "rule-neutral";
                    let icon = "•";

                    if (rule.checkable) {
                        className = rule.valid ? "rule-ok" : "rule-error";
                        icon = rule.valid ? "✔" : "✖";
                    }

                    return (
                        <li
                            key={rule.key}
                            className={className}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                            }}
                        >
                            <span>{icon}</span>
                            <span>{rule.label}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default PasswordRules;
